<template>

  <figure v-if="template" class="root">
    <img v-if="template.teiStrTipoCabec == 'I'" :src="template.teiStrCabec" class="cabec" />
    <figcaption v-else class="cabec" :class="[template.teiStrTipoCabec]">{{template.teiStrCabec}}</figcaption>
    <div class="container-imagem">
      <img :src="anuncio.imagem" class="image-fit" />
      <img v-if="template.teiStrTipoMarca == 'I'" class="image-fit marca-dagua" :src="template.teiStrMarca" alt="">
      <figcaption v-else class="marca-dagua">{{template.teiStrMarca}}</figcaption>
    </div>
    <img v-if="template.teiStrTipoRodap == 'I'" :src="template.teiStrRodap" class="rodap" />
    <figcaption v-else class="rodap" :class="[template.teiStrTipoRodap]">{{template.teiStrRodap}}</figcaption>
  </figure>

  <figure v-else class="root">
      <img :src="anuncio.imagem" class="image-fit" />
  </figure>

</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: ["anuncio"],
    data(){
      return {
        template: null
      }
    },
    computed: {
     ...mapGetters({
      config: "cliente/config"
     })
    },
    mounted(){
      this.template = this.config.templateImagem;
    }
  }
</script>

<style scoped>

  .root {
    height: 100%;
  }

  .image-fit {
    display: block;
    object-fit: contain;
    width:  100%;
    height: 100%;
  }

  .container-imagem {
    position: relative;
    height: calc(100% - 80px);
  }

  .marca-dagua {
    position: absolute;
    opacity: .5;
    left:  50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .cabec, .rodap {
    width: 100%;
    height: 40px;
    object-fit: contain;
  }

  .TD, .TE, .TC {
    line-height: 30px;
    padding: 5px 10px;
  }
  .TD {
    text-align: right;
  }
  .TE {
    text-align: left;
  }
  .TC {
    text-align: center;
  }

</style>